import api from '@pray/shared/utils/api';

export async function getStripoToken() {
  const url = `/web/studio/tokens/stripo`;
  const response = await api.executeGetRequest(url);

  return response.data;
}
